// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__h1LFS","footer":"styles_footer__1qo-w"};